import React from "react";
import { MdOutlineRemoveRedEye } from "react-icons/md";

export default function MobileClientProjects({ projects = [], onView }) {
  if (!projects || projects.length === 0) {
    return (
      <p className="text-center text-gray-500 text-sm py-6">
        No projects found
      </p>
    );
  }

  return (
    <div className="flex flex-col gap-3">
      {projects.map((project) => (
        <div
          key={project.id}
          onClick={() => onView(project)}
          className="
            relative
            bg-gray-50
            border
            rounded-md
            shadow-sm
            p-4
            cursor-pointer
            active:scale-[0.98]
            transition
          "
        >
          {/* Eye Icon */}
          <MdOutlineRemoveRedEye
            className="absolute top-3 right-3 text-gray-600 bg-white rounded-full p-1 text-3xl"
            onClick={() => onView(project)}
          />

          {/* Project ID */}
          <p className="text-xs text-gray-500 font-medium">
            Project ID
          </p>
          <p className="text-sm text-gray-800">
            {project.id}
          </p>

          {/* Project Name */}
          <p className="text-xs text-gray-500 font-medium mt-2">
            Project Name
          </p>
          <p className="text-base font-semibold text-gray-900 leading-snug">
            {project.projectName}
          </p>
        </div>
      ))}
    </div>
  );
}
